export function Edit({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path d="M13.2333 4.90001L11.1 2.76668L11.8 2.06668C11.9889 1.87779 12.225 1.78613 12.5083 1.79168C12.7917 1.79724 13.0278 1.89446 13.2167 2.08335L13.9333 2.80001C14.1222 2.9889 14.2167 3.22224 14.2167 3.50001C14.2167 3.77779 14.1222 4.01113 13.9333 4.20001L13.2333 4.90001ZM12.5333 5.60001L4.13333 14H2V11.8667L10.4 3.46668L12.5333 5.60001Z" />
    </svg>
  )
}
